import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { TaxonomyItemProps, TaxonomyItemType } from './types';

interface TaxonomyItemWithChildrenProps extends TaxonomyItemProps {
  depth: number; // To track indentation level
}

const TaxonomyItem: React.FC<TaxonomyItemWithChildrenProps> = ({ item, taxonomy, updateParent, editItem, depth }) => {
  const [, dragRef] = useDrag(() => ({
    type: 'TAXONOMY_ITEM',
    item: { id: item.id },
  }));

  const [, dropRef] = useDrop(() => ({
    accept: 'TAXONOMY_ITEM',
    drop: (draggedItem: { id: number }) => {
      if (draggedItem.id !== item.id) {
        updateParent(draggedItem.id, item.id);
      }
    },
  }));

  // Find children of the current item
  const children = taxonomy.filter(child => child.parent_id === item.id);

  return (
    <div>
      <div
        ref={(node) => dragRef(dropRef(node))}
        className="card mb-2 p-2"
        style={{ marginLeft: `${depth * 20}px` }} // Indent based on depth level
      >
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <strong>{item.name}</strong>
          </div>
          <div>
            <button className="btn btn-link p-0 text-decoration-none" onClick={() => editItem(item)}>
              Edit
            </button>
          </div>
        </div>
      </div>

      {/* Render child items recursively */}
      {children.map(child => (
        <TaxonomyItem
          key={child.id}
          item={child}
          taxonomy={taxonomy}
          updateParent={updateParent}
          editItem={editItem}
          depth={depth + 1}
        />
      ))}
    </div>
  );
};

export default TaxonomyItem;
